import { IRouteBase } from './routes.interface'
import { Guards, ListLayout } from './layouts'

//import routesImport from '../../assets/microapp.json'
import { loadRemoteModule } from '@angular-architects/module-federation'
import {
  startsWith,
  WebComponentWrapper,
  WebComponentWrapperOptions,
} from '@angular-architects/module-federation-tools'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../environments/environment'
import { PageNotFoundComponent } from '../views/page-not-found/page-not-found.component'
import { PageTimeoutComponent } from '../views/page-timeout/page-timeout.component'
import { RedirectPageComponent } from '../views/redirect-page/redirect-page.component'
import { Route } from '@angular/router'
import { DynamicRoutes } from '../interfaces/routes.interface'
import { PATHS } from '../utils/default-routes'

export class RoutingDetail {
  //Dynamic Routes config by flow
  routesImport: DynamicRoutes = require('../../assets/microapp.json')
  flow: string = window.location.pathname.split('/')[1] || 'transaccional'
  process: string = window.location.pathname.split('/')[2] || 'autogestion'
  sessionStorage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })
  baseRoute: Route = {
    path: '**',
    component: PageNotFoundComponent,
  }
  timeoutRoute: Route = {
    path: 'expirada',
    component: PageTimeoutComponent,
  }
  redirectTransactionalRoute: Route = {
    path: 'redireccion',
    component: RedirectPageComponent,
  }
  async routerModule(value: Partial<IRouteBase>) {
    try {
      const moduleReult = await loadRemoteModule({
        type: value.type,
        remoteEntry: value.urlResource || '',
        exposedModule: value.exposedModule || '',
      })
      return moduleReult.MFModule
    } catch (error) {
      location.href = '/'
    }
  }
  routerList() {
    const dynamicRoutes = this.routesImport[this.process]?.[this.flow] ? this.routesImport[this.process]?.[this.flow] : PATHS
    const mapRoutes: any[] = dynamicRoutes.map((value: Partial<IRouteBase>) => {
      return value.fwr === 'react' ? this.mapRouteReact(value) : this.mapRouteAngular(value)
    })
    return [...mapRoutes, this.timeoutRoute, this.redirectTransactionalRoute, this.baseRoute]
  }

  mapRouteAngular = (value: Partial<IRouteBase>): Route => {
    let { layout, guards, scope } = value
    layout = layout ?? 'dashboard'
    guards = guards ?? []
    return {
      path: scope,
      component: ListLayout[layout],
      children: [
        {
          path: '',
          loadChildren: () => this.routerModule(value),
          canActivate: guards.map((guard: string) => {
            return Guards[guard]
          }),
        },
        {
          ...this.baseRoute,
        },
      ],
    }
  }

  mapRouteReact = (value: Partial<IRouteBase>) => {
    let { name, layout, guards, scope } = value
    layout = layout || 'dashboard'
    name && this.sessionStorage.set(name, { name: value.scope })
    guards = guards ?? []
    return {
      path: scope,
      component: ListLayout[layout],
      canActivate: guards.map((guard: string) => {
        return Guards[guard]
      }),
      children: [
        {
          matcher: startsWith(''),
          component: WebComponentWrapper,

          data: {
            type: value.type,
            remoteEntry: value.urlResource || '',
            remoteName: value.name,
            exposedModule: value.exposedModule || '',
            elementName: value.exposedModule?.replace('./', ''),
          } as WebComponentWrapperOptions,
        },
      ],
    }
  }
}
